// All of SNS icon should be integrated in this component.
// This is an DYNAMIC component used to provide all social media icon with any state that social media has
// Eg: we can easy to change color of simple social icon like Twitter, Youtube...but sometimes we can't.
// Some complicated icon like Instagram, Tiktok, Threads are need to config for each state.
import { cn } from '@anytag/shared-utils';
import { IconNames } from '@anytag/shared-assets';
import { SupportedSocialMediaType } from '@anytag/shared-types';
import { Icon, IconProps } from '../../Icon';
import { MediaPreview } from '../../MediaPreview';
import { IconType, Variant } from './types';
import { socialIconConfigs } from './utils';

export interface SocialIconProps extends Omit<IconProps, 'icon' | 'variant'> {
  variant?: Variant;
  onClick?: () => void;
  type: keyof typeof SupportedSocialMediaType;
}

export const SocialIcon = ({ size = '16px', type, variant = 'original', ...restProps }: SocialIconProps) => {
  const iconProps = ((): IconType & { icon: IconNames | '' } => {
    let selected;
    switch (type) {
      case 'FACEBOOK':
      case 'FACEBOOK_PAGE':
        selected = socialIconConfigs.FACEBOOK;
        break;
      case 'INSTAGRAM':
      case 'INSTAGRAM_REEL':
        selected = socialIconConfigs.INSTAGRAM;
        break;
      case 'INSTAGRAM_STORY':
      case 'INSTAGRAM_BUSINESS':
        selected = socialIconConfigs.INSTAGRAM_STORY;
        break;
      case 'XHS':
        selected = socialIconConfigs.XHS;
        break;
      default:
        selected = socialIconConfigs[type];
        break;
    }

    return { icon: selected?.icon || '', ...(selected?.variant?.[variant] || {}) };
  })();

  return iconProps?.src ? (
    // This is temporary solution while Icomoon not support the gradient icon, just need to put necessary props
    <MediaPreview
      src={iconProps.src}
      onClick={restProps.onClick}
      style={{ ['--size' as string]: typeof size === 'string' ? size : `${size}px` }}
      className={cn('inline-block size-[var(--size)] bg-transparent', restProps.className)}
    />
  ) : (
    <Icon variant="none" size={size} {...iconProps} {...restProps} />
  );
};
